/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';


function DeliveryProfilesDeliveryItemsSearchViewController(this: JS5Object, _: JS5Object, $location: JS5Object, $q: JS5Object,
                                                           $routeParams: JS5Object, uiGridConstants: JS5Object,
                                                           PartnerEditService: JS5Object, BreadcrumbService: JS5Object): void {
    const getData = () => {
        this.loadingIndicator.show = true;
        PartnerEditService.getDeliveryProfile($routeParams.deliveryProfileId).then((deliveryProfile: JS5Object) => {
            this.gridOptions.data = [];
            if (this.hideEmpty) {
                _.forEach(deliveryProfile.deliveryItemCounts, (deliveryItemCount: JS5Object) => {
                    if (deliveryItemCount.numberOfArchiveItems !== "0"
                        || deliveryItemCount.numberOfArtworkItems !== "0"
                        || deliveryItemCount.numberOfAudioItems !== "0"
                        || deliveryItemCount.numberOfClosedCaptioningItems !== "0"
                        || deliveryItemCount.numberOfImageItems !== "0"
                        || deliveryItemCount.numberOfMetadataItems !== "0"
                        || deliveryItemCount.numberOfSubtitleItems !== "0"
                        || deliveryItemCount.numberOfVideoItems !== "0") {
                        this.gridOptions.data.push(deliveryItemCount);
                    }
                });
            } else {
                this.gridOptions.data = deliveryProfile.deliveryItemCounts;
            }
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    let columnDefinitions = [
        {
            field: 'mAPName',
            displayName: 'From Video Map',
            sort: {
                direction: 'asc',
            },
            width: '800',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfVideoItems',
            displayName: '# Videos',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfAudioItems',
            displayName: '# Audios',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfArtworkItems',
            displayName: '# Artwork',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfImageItems',
            displayName: '# Images',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfClosedCaptioningItems',
            displayName: '# CCs',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfSubtitleItems',
            displayName: '# Subtitles',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfMetadataItems',
            displayName: '# Metadata',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        },
        {
            field: 'numberOfArchiveItems',
            displayName: '# Archives',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    const navigateToDeliveryProfilesEditViewFromDoubleClick = (row: JS5Object): void => {
        $location.url(`/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}/deliveryItems/edit/${row.mAPId}`)
    };

    this.onRowDblClick = (row: JS5Object) => {
        navigateToDeliveryProfilesEditViewFromDoubleClick(row.entity);
    };

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: false,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: false,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: false,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object): void => {
            this.gridApi = gridApi;
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        data: []
    };
    this.toolbarCheckboxDefs = [
        {
            label: 'Hide Empty',
            onUpdate: (newValue: boolean): void => {
                this.hideEmpty = newValue;
                getData();
            },
            isChecked: this.hideEmpty
        }
    ];
    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
        setupBreadcrumbs();
    };
    const setupBreadcrumbs = () => {
        const breadCrumbSize = _.size(BreadcrumbService.getBreadcrumbs());
        if (breadCrumbSize === 0 || breadCrumbSize === 1) {
            BreadcrumbService.addBreadcrumb({
                name: this.resolveData.partnerName,
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles`
            });
            BreadcrumbService.addBreadcrumb({
                name: 'Delivery Profiles',
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}`,
                params: {tab: 'deliveryItems'}
            });
            BreadcrumbService.addBreadcrumb({
                name: this.resolveData.mediaAcceptProfile.name,
                location: `/system/partners/edit/${$routeParams.id}/deliveryProfiles/edit/${$routeParams.deliveryProfileId}/deliveryItems/edit/${$routeParams.mediaAcceptProfileId}`,
                params: {tab: 'videos'}
            });
        }
    }
}

angular.module('prism-ui.deliveryProfiles').component('deliveryProfilesDeliveryItemsSearchView', {
    controller: DeliveryProfilesDeliveryItemsSearchViewController,
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/searchView/delivery-profiles-delivery-items-search-view-template.html'
});
